<h2 mat-dialog-title>
  @if (isEdit) {
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
    Rediger afdeling
  } @else {
    <mat-icon svgIcon="add_home"></mat-icon>
    Opret afdeling
  }
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>

@if (departmentGroups$ | async; as departmentGroups) {
  <form [formGroup]="dialogForm" (submit)="save()">
    <mat-dialog-content>
      <div class="form-row">
        <mat-form-field>
          <mat-label>Afdelingsnavn</mat-label>
          <input type="text" matInput formControlName="departmentName" />
          @if (dialogForm.controls.departmentName.hasError('required')) {
            <mat-error>{{ getControlErrorMessage('departmentName', 'required') }}</mat-error>
          }
          @if (dialogForm.controls.departmentName.hasError('whitespace')) {
            <mat-error>{{ getControlErrorMessage('departmentName', 'empty') }}</mat-error>
          }
          @if (dialogForm.controls.departmentName.hasError('minlength')) {
            <mat-error>{{ getControlErrorMessage('departmentName', 'minLength') }}</mat-error>
          }
          @if (dialogForm.controls.departmentName.hasError('maxlength')) {
            <mat-error>{{ getControlErrorMessage('departmentName', 'maxLength') }}</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row margin--bottom-none">
        <mat-form-field>
          <mat-label>Gruppe</mat-label>
          <mat-select formControlName="departmentGroup" okCustomDropDownArrowDirective>
            <mat-option> Ingen </mat-option>
            @for (dg of departmentGroups.items; track dg.id) {
              <mat-option [value]="dg.id" [title]="dg.name">
                {{ dg.name }}
              </mat-option>
            }
          </mat-select>
          <mat-icon matSuffix></mat-icon>
        </mat-form-field>
      </div>
      <div class="form-row">
        <div class="help-icon-wrapper">
          <mat-icon [matTooltip]="g4Info" role="img" aria-hidden="true" data-mat-icon-type="font"> help_outline </mat-icon>
        </div>
        <adm-g4-business-account-number [control]="this.dialogForm.controls.invoicingAccountNumber" />
      </div>
      <div class="form-row margin--top-none margin--bottom-none">
        <div class="help-icon-wrapper">
          <mat-icon [matTooltip]="okAftaleNr" role="img" aria-hidden="true" data-mat-icon-type="font"> help_outline </mat-icon>
        </div>
        <adm-g4-agreement-number [control]="this.dialogForm.controls.agreementNumber" [required]="false" />
      </div>
      <div class="form-row">
        <adm-dep-address-typeahead
          style="width: 100%"
          [initialAddress]="initialAddress()"
          [parentFormGroup]="dialogForm"
          [addressWithoutDARValidation]="dialogForm.controls.addressWithoutDARValidation.value"
          (addressSelected)="selectAddress($event)" />
        <div class="form-row margin--bottom-l">
          <mat-slide-toggle formControlName="addressWithoutDARValidation" color="primary">
            <div class="flex flex-col">
              Angiv lokationens adresse uden DAR validering
              <mat-hint class="hint">Brug hvis adressen f.eks. ikke findes endnu.</mat-hint>
            </div>
          </mat-slide-toggle>
        </div>
        <div class="form-row">
          <mat-slide-toggle formControlName="isHeadquarter" color="primary">Hovedkontor</mat-slide-toggle>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button class="actions__button margin--right-2" mat-dialog-close type="button" mat-button>Annuller</button>
      @if (dialogForm) {
        <button type="submit" mat-raised-button color="primary" [disabled]="!dialogForm.valid || isLoading">
          {{ submitBtnValue }}
        </button>
      }
    </mat-dialog-actions>
  </form>
}
